module.exports = __webpack_public_path__ + "img/qrcode.6726e010.png";